export default {
  setSuggestions: 'suggestions',
}
